export default {
  setSuggestions: 'suggestions',
}
